import SellIn from '../../spa/sell-in/SellIn';

export default {
  path: 'sellin',
  name: 'sellin',
  component: SellIn,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/sell-in.js